import React, { useCallback, useEffect, useState } from 'react';
import { object, string } from 'prop-types';

import {
  getDetailMFTransactionDeposit,
  getDetailMFTransactionWithdraw,
} from '@services/api/platform/mutual-fund';
import { SkeletonLoad } from 'Component/Skeleton';

import useEventTracker from '../../tracker';
import { styContainerExpandable, textContent, textLabel } from './style';

function ExpandableMFDetail({ item, source }) {
  const [mfTransactionDetail, setMfTransactionDetail] = useState(null);
  const { eventExpandOrderDetail } = useEventTracker();

  const fetchMFDeposit = useCallback(async () => {
    const response = await getDetailMFTransactionDeposit(item.transaction[0]?.id);
    if (response) setMfTransactionDetail(response);
  }, [getDetailMFTransactionDeposit]);

  const fetchMFWithdraw = useCallback(async () => {
    const response = await getDetailMFTransactionWithdraw(item.transaction[0]?.id);
    if (response) setMfTransactionDetail(response);
  }, [getDetailMFTransactionWithdraw]);

  useEffect(() => {
    setMfTransactionDetail(null);
    eventExpandOrderDetail(item, source);
    if (item.type === 'deposit') fetchMFDeposit();
    if (item.type === 'withdraw') fetchMFWithdraw();
  }, []);

  return (
    <div className={styContainerExpandable}>
      {!mfTransactionDetail ? (
        <>
          <SkeletonLoad height={20} />
          <SkeletonLoad height={20} style={{ marginTop: 12 }} />
        </>
      ) : (
        <>
          <div style={{ display: 'flex' }}>
            <div className={textLabel} style={{ width: 230, display: 'flex' }}>
              NAB/Unit <div className={textContent}>{item.status_transaction}</div>
            </div>
            <div className={textLabel} style={{ marginLeft: 14 }}>
              No. Transaksi <span className={textContent}>{mfTransactionDetail?.ref_code}</span>
            </div>
          </div>
          <div style={{ display: 'flex' }}>
            <div className={textLabel} style={{ width: 230 }}>
              Jumlah{' '}
              <span className={textContent}>{mfTransactionDetail?.unit?.slice(0, -2) || '-'}</span>
            </div>
            <div className={textLabel} style={{ marginLeft: 14, display: 'flex' }}>
              Rekening Tujuan{' '}
              <div className={textContent}>
                {mfTransactionDetail?.fund?.transfer_bank ||
                  mfTransactionDetail?.destination?.bank_name}
                {' - '}
                {mfTransactionDetail?.fund?.fund_bundle_name ||
                  mfTransactionDetail?.destination?.account_name}
                {' - '}
                {mfTransactionDetail?.fund?.bank_account ||
                  mfTransactionDetail?.destination?.account_number}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

ExpandableMFDetail.propTypes = {
  item: object,
  source: string,
};

ExpandableMFDetail.defaultProps = {
  item: {},
  source: '',
};

export default React.memo(ExpandableMFDetail);
